module.exports = __webpack_public_path__ + "img/business-account.5d1b4c22.svg";